/* Visionneuse produit — miniatures, fleches clavier, glissement tactile.
   S'appuie sur la classe .active que product-modal.js pose deja.
   Ajoute le 02/09/2026. */
(function () {
  const SEL_MEDIA = '.product-media-modal__content > [data-media-id]';

  function init(modal) {
    if (modal.dataset.lightboxPret) return;
    modal.dataset.lightboxPret = '1';

    const bande = modal.querySelector('.lightbox-vignettes');
    const medias = () => Array.from(modal.querySelectorAll(SEL_MEDIA));

    if (medias().length < 2) modal.setAttribute('data-une-seule', '');

    function afficher(mediaId) {
      medias().forEach((m) => m.classList.toggle('active', m.dataset.mediaId === String(mediaId)));
      if (!bande) return;
      bande.querySelectorAll('.lightbox-vignette').forEach((b) => {
        const actif = b.dataset.mediaId === String(mediaId);
        b.setAttribute('aria-current', actif ? 'true' : 'false');
        if (actif) b.scrollIntoView({ block: 'nearest', inline: 'center' });
      });
    }

    function decaler(pas) {
      const liste = medias();
      if (liste.length < 2) return;
      const i = liste.findIndex((m) => m.classList.contains('active'));
      const suivant = liste[(i + pas + liste.length) % liste.length];
      if (suivant) afficher(suivant.dataset.mediaId);
    }

    if (bande) {
      bande.addEventListener('click', (e) => {
        const b = e.target.closest('.lightbox-vignette');
        if (b) afficher(b.dataset.mediaId);
      });
    }

    modal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); decaler(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); decaler(-1); }
    });

    // glissement tactile
    let x0 = null;
    const zone = modal.querySelector('.product-media-modal__content');
    if (zone) {
      zone.addEventListener('touchstart', (e) => { x0 = e.changedTouches[0].clientX; }, { passive: true });
      zone.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) decaler(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    // product-modal.js pose .active a l'ouverture : on synchronise la bande juste apres
    modal.addEventListener('lightbox:sync', () => {
      const actif = modal.querySelector(SEL_MEDIA + '.active');
      if (actif) afficher(actif.dataset.mediaId);
    });
  }

  function tout() { document.querySelectorAll('product-modal').forEach(init); }

  document.addEventListener('DOMContentLoaded', tout);
  if (document.readyState !== 'loading') tout();

  // a l'ouverture de la visionneuse, Dawn appelle showActiveMedia() : on s'y raccroche
  const attendre = setInterval(() => {
    const C = customElements.get('product-modal');
    if (!C) return;
    clearInterval(attendre);
    if (C.prototype.__lightboxPatch) return;
    C.prototype.__lightboxPatch = true;
    const original = C.prototype.showActiveMedia;
    C.prototype.showActiveMedia = function () {
      original.call(this);
      init(this);
      this.dispatchEvent(new CustomEvent('lightbox:sync'));
    };
  }, 60);
  setTimeout(() => clearInterval(attendre), 8000);
})();
